var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "noListData", class: _vm.listDataStyle }, [
    _c("div", [
      _c("div", { staticClass: "no-img" }),
      _c("div", { staticClass: "no-text" }, [
        _vm._v(" " + _vm._s(_vm.$t("common.noListData")) + " "),
      ]),
    ]),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }